import React, { FC, useEffect, useState } from 'react'

import { useAddShareLinkVisitor } from './use-add-link-visitor'

import { JoinBoardButton } from 'src/components/board/v2/share-link/join-board-button'
import { VisitBoardButton } from 'src/components/board/v2/share-link/visit-board-button'

interface JoinBoardProps {
  isBoardFollower: boolean
  isShareLinkVisitor: boolean
  boardId: string
  tokenId: string
  networkName: string
}

export const JoinBoard: FC<JoinBoardProps> = ({
  isShareLinkVisitor,
  isBoardFollower,
  networkName,
  boardId,
  tokenId
}) => {
  const [boardJoined, setBoardJoined] = useState(false)
  const [visitorAdded, setVisitorAdded] = useState(false)
  const { addShareLinkVisitor } = useAddShareLinkVisitor({ boardId, tokenId })

  useEffect(() => {
    if (!isShareLinkVisitor && !visitorAdded) {
      addShareLinkVisitor()
      setVisitorAdded(true)
    }
  }, [isShareLinkVisitor, addShareLinkVisitor, visitorAdded, setVisitorAdded])

  const renderMessage = () => {
    if (boardJoined) {
      return 'Congratulations! You are now a part of this community.'
    }

    return isBoardFollower
      ? 'Looks like you have already joined.'
      : 'Would you like to join?'
  }

  return (
    <>
      <p className="mb-4 text-neutral-600">{renderMessage()}</p>
      {isBoardFollower || boardJoined ? (
        <VisitBoardButton
          networkName={networkName}
          boardId={boardId}
          isBoardFollower={isBoardFollower}
          boardJoined={boardJoined}
        />
      ) : (
        <JoinBoardButton
          boardId={boardId}
          tokenId={tokenId}
          setBoardJoined={setBoardJoined}
        />
      )}
    </>
  )
}
